module.exports = __webpack_public_path__ + "img/luyuanCustomerT3.4e8cb66d.png";